export const DASHBOARD_TYPE = {
  ED: "ED",
  BREACH: "BREACH",
  BED_STATISTICS: "BED_STATISTICS",
};
